type Props = {
	children: React.ReactNode;
};

export const QuestionSectionWrapper = ({ children }: Props) => {
	return <div className="flex flex-wrap items-center gap-2 text-sm">{children}</div>;
};

QuestionSectionWrapper.displayName = "QuestionSectionWrapper";
